export default __webpack_public_path__ + "static/media/placeholder_private01-es-mobile.f5298a0c.png";